import { useRef, useEffect, useState } from 'react'
import { connect } from 'react-redux'
import {
  Button,
  Card,
  Popover,
  Typography
} from 'antd'
import { generateFieldData } from './helpers'
import { Check, Edit, X } from 'react-feather'
import { RelationLabels } from 'Model'
import { setRelationLabels } from 'Actions/explore'
import { QuestionCircleOutlined } from '@ant-design/icons'
import RegistryForm from './RegistryForm'
import WeaverService from 'Services/WeaverService'
import Feather from '@sysunite/react-feather'
{ Paragraph, Text } = Typography

helpText = (<div style={{ width: 500, lineHeight: '1.6rem' }}>
  <Paragraph style={{ width: 500, lineHeight: '1.6rem' }}>
    The <Text code>Relation labels</Text> are used to give <Text mark>relation keys</Text> readable aliases within a project
    Multiple <Text code>relation labels</Text> can be configured.
  </Paragraph>
  <Text type="secondary">
    Note: Changing this will not actually update anything in the database, just how the app reads from the database.
    So, if you change this just to explore, and then later change it back, the data and app views will look the same as they did previously.
  </Text>
</div>)

info = (
  <Popover
    content={helpText}
    title='Relations Map'
    trigger="click"
    placement="left"
  >
    <a><QuestionCircleOutlined /></a>
  </Popover>
)

RelationLabelsPanel = ({ relationLabels, setRelationLabels }) ->

  [isEditing, setIsEditing] = useState(false)
  [loading, setLoading] = useState(true)
  [configNode, setConfigNode] = useState(undefined)

  formRef = useRef()

  useEffect( ->
    ( ->
      configNode = await RelationLabels.load()
      setConfigNode(configNode)
      setLoading(false)
    )()
    undefined
  , [])

  useEffect( ->
    fieldData = generateFieldData(relationLabels, 'relationLabelsForm')
    resetForm(fieldData)
  , [isEditing])

  resetForm = (fieldData) ->
    formRef.current?.resetFields()
    formRef.current?.setFields(fieldData)

  generateRelationLabelMap = ->
    { relationLabelsForm } = formRef.current.getFieldsValue()
    _.reduce(relationLabelsForm, (acc, value) ->
      {
        acc...
        [value.key]: value.value
      }
    , {})

  actions = (
    if isEditing
      [
        <Button
          data-testid="complete-editing-relation-labels"
          type="text"
          onClick={ ->
            relationLabelMap = generateRelationLabelMap()
            await configNode.update(relationLabelMap)
            setRelationLabels(relationLabelMap)
            setIsEditing(false)
          }
        >
          <Check />
        </Button>
        <Button
          data-testid="cancel-editing-relation-labels"
          type="text"
          onClick={ -> setIsEditing(false)}
        >
          <X />
        </Button>
      ]
    else
      [
        <Button
          data-testid="edit-relation-labels"
          type="text"
          disabled={!WeaverService.userCanEdit()}
          onClick={ -> setIsEditing(true)}
        >
          <Edit />
        </Button>
      ]
  )

  <Card
    title="Relation Labels"
    loading={loading}
    actions={actions}
    extra={info}
    size="small"
    id="RelationLabels"
  >
    <RegistryForm
      data={relationLabels}
      formRef={formRef}
      formName="relationLabelsForm"
      item="relation"
      isEditing={isEditing}
    />
  </Card>

export default connect(({ explore }) ->
  { relationLabels: explore.relationLabels }
, { setRelationLabels })(RelationLabelsPanel)
